/* 
 */

import React, {useState, useEffect, useCallback}                 from 'react'

import {DismissButton, PersonAdd, PersonRemove}                  
                                                    from '../../lib/iprs-react-library/src/index.js'

const TeamEditOverlay = ({api, eventDispatch, state}) => {
    
    const { team: {teamID = 0} }            = state
                                                
    const [members,   setMembers]           = useState([])
    const [users,     setUsers]             = useState([])
    
    const [err, setErr]                     = useState('')

    const loadTeam = useCallback(() => {
        if( teamID ){ 
            api.getTeamMemberList(teamID)
                .then( response => response.apiResult )
                .then(
                    apiResult => { 
                        setMembers( apiResult )
                        setErr(null)
                    }
                )
                .catch( err => setErr( err.message ) )
        }
    },[api, teamID])

    useEffect( () => loadTeam(), [teamID, loadTeam])
    useEffect( () => {
        
        if( teamID ){ 
            api.listDiaryUsers()
            .then( response => response.apiResult )
            .then( du => du.filter( u => null != u.FirstName && null != u.LastName ) ) // remove null FirstNames found in UAT
            .then( du => du.sort( (r1, r2) => ('' + r1.LastName + ' ' + r1.FirstName).localeCompare(('' + r2.LastName + ' ' + r2.FirstName)) ) )
            .then(
                apiResult => { 
                    setUsers( apiResult )
                    setErr(null);
                }
            )
            .catch( err => setErr( err.message ) )
        }
    }, [teamID, api])
    

    
    const addPerson = (partyID) => {
        
        api.addMemberToTeam( partyID, teamID )
            .then( response =>  response.apiResult )
            .then( apiResult => { loadTeam(); setErr(null) } )
            .catch( err => setErr( err.message ) )
    }
    
    const handleDismiss = () => {
        eventDispatch( { team: { editTeam: false } } )
    }
    
    const handleClick = e => {
        
        const partyID = e.target.value
        
        api.removeMemberFromTeam( partyID, teamID )
            .then( response =>  response.apiResult )
            .then( apiResult => { loadTeam(); setErr(null) } )
            .catch( err => setErr( err.message ) )
    }
    
    return <div style={{position: 'absolute', display: 'block', top: '50%', 
            left: '50%',backgroundColor: 'white', zIndex: '100', padding: '2em', 
            border: '3px solid var(--colour__primary)'}}>
        
        <PersonSelect addPerson={addPerson} users={users} members={members} />
    
        <ul className='stdList' >
            {members
                .sort((m1, m2) => ('' + m1.LastName + ' ' + m1.FirstName).localeCompare('' + m2.LastName + ' ' + m2.FirstName ))
                .map(m => (<li key={m.pkPartyID}><div className='listLabel sideMenuLink-anchor'>{m.FirstName + ' ' + m.LastName}</div>
                    <div className='sideMenuButtons' >
                        <PersonRemove key={m.pkPartyID} value={m.pkPartyID} onClick={handleClick} name={'personRemove'} />
                    </div>
                </li>) )}
        </ul>
        
        <DismissButton onClick={handleDismiss} />
        
        <p>{err}</p>
        
    </div>
}

const PersonSelect = ({addPerson, users, members}) => {

    const [partyID, setPartyID] = useState(0);
    const memberIds = members.map(m => m.pkPartyID);
    const noneMembers = users.filter(u => !memberIds.includes(u.PartyID));
    const firstNoneMember = noneMembers.length ? noneMembers[0].PartyID : 0;

    useEffect(() => {

        setPartyID(firstNoneMember);

    }, [firstNoneMember]);

    const handleClick = e => {
        e.preventDefault()
        
        addPerson( partyID );
    }
    
    const handleChange = v => {

        const partyID = Number.parseInt('' + v.target.value, 10);

        setPartyID(partyID);

    }
    
    return (<>
            <select onChange={handleChange} value={`${partyID}`} className='float' >
            {createOptions(noneMembers )}
            </select>
            <PersonAdd     onClick={handleClick} name={'personAdd'}  />
        </>)
}

const createOptions = (noneMembers) => {

    /* filter out users who are already members of the  team and sort on Last Name*/
    return noneMembers
        .filter( u => null != u.FirstName && null != u.LastName ) // remove null FirstNames found in UAT
        .sort( (r1, r2) => ('' + r1.LastName + ' ' + r1.FirstName).localeCompare(('' + r2.LastName + ' ' + r2.FirstName)) )
        .map( u => <option value={u.PartyID} >{u.FirstName + ' ' + u.LastName}</option> );
}

export default TeamEditOverlay


